import { render, staticRenderFns } from "./navigation_rail.vue?vue&type=template&id=178d3b2d"
import script from "./navigation_rail.vue?vue&type=script&lang=js"
export * from "./navigation_rail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports